// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import utilities
// @end

// @import types
import { IFetchQualifications } from 'app_types/campus/academic/qualificationsTypes'
// @end

class QualificationsService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor() {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  fetchQualifications = async (params: any) => {
    this.refreshAuthToken()

    // moodle ID of current user
    let user = this.storeObject?.getState().auth?.user?.data
    params.userID = user.moodle.moodle_id;
    console.log("Grades for " + params.userID + " in course " + params.courseID) ;

    let responseData: IFetchQualifications

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/grades`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)
    console.log(responseData);

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    // // TODO: Pendiente de integrar backend
    // let responseData: IFetchQualifications = {
    //   qualifications: [
    //     {code: '5062', name: 'Example date one', date: '2020-02-03'},
    //     {code: '5063', name: 'Example date two', date: '2020-02-04'},
    //     {code: '5064', name: 'Example date three', date: '2020-02-05'},
    //   ],
    //   status: '200',
    //   message: 'success',
    //   status_code: 'success',
    //   code: 200
    // }
    return responseData

    //return false
  }
}

export default QualificationsService
